import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationKochiPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationKochi,
);
